import { combineClasses } from "@kikoff/utils/src/string";

import ExpressiveIcon from "../assets/ExpressiveIcon";

import styles from "./WithIcon.module.scss";

interface WithIconProps extends React.ComponentPropsWithoutRef<"div"> {
  name: ExpressiveIcon.Name;
}

export default function WithIcon({
  name,
  className,
  children,
  ...props
}: WithIconProps) {
  return (
    <div className={combineClasses(styles["with-icon"], className)} {...props}>
      <div>{children}</div>
      <ExpressiveIcon name={name} size={40} />
    </div>
  );
}
